import React, { useState, useEffect } from "react";
import Welcome from "./Welcome";
import { Link } from "react-router-dom";
import EmployerSignIn from "../components/SignIn/EmployerSignIn";
import StudentSignIn from "../components/SignIn/StudentSignIn";
import { url } from "../data/url";
import axios from 'axios';

const SignInPage = () => {
  const [userType, setUserType] = useState("jobSeeker");
    const [serverError, setServerError] = useState("");
    const [showPopup, setShowPopup] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMessage, setResetMessage] = useState("");

    const handleUserTypeChange = (type) => {
        setUserType(type);
    }; 

  const handleServerError = (error) => {
    setServerError(error);
  }; 

  const handleForgotPasswordClick = () => {
    setShowPopup(true);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };
  
  axios.defaults.withCredentials = true;

  const handleResetPasswordSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${url.path}/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: resetEmail, userType, forgetPassword: true }),
      });

      const data = await response.json();
      setResetMessage(data.message);

      // Close the popup and reset state after 5 seconds
      setTimeout(() => {
        setShowPopup(false);
        setResetEmail("");
        setResetMessage("");
      }, 5000);
    } catch (error) {
      console.error('Error:', error);
      setResetMessage('An error occurred. Please try again later.');
    }
  };

  useEffect(() => {
    let timer;
    if (resetMessage) {
      timer = setTimeout(() => {
        setShowPopup(false);
        setResetMessage("");
      }, 7000);
    }
    return () => clearTimeout(timer);
  }, [resetMessage]);


  
  return (
    <>
    <div className={`auth-background${!showPopup ? "" : "-blur"}`}>
      <div className="left-section">
        <Welcome />
      </div>
      <div className="right-section">
        <div className="login-card">
          <h2 className='auth-name'>Sign In</h2>
          {serverError && <div className="error server-error">{serverError}</div>}
          <p>Access your account to explore opportunities</p>
          <div className="user-type-switch">
              <button 
                className={userType === "employer" ? "active" : ""}
                onClick={() => handleUserTypeChange("employer")}
              >
                Employer
              </button>
              <button 
                className={userType === "jobSeeker" ? "active" : ""}
                onClick={() => handleUserTypeChange("jobSeeker")}
              >
                Intern
              </button>
            </div>
            {userType === "employer" && <EmployerSignIn handleServerError={handleServerError} handleForgotPasswordClick={handleForgotPasswordClick}/>}
            {userType === "jobSeeker" && <StudentSignIn handleServerError={handleServerError} handleForgotPasswordClick={handleForgotPasswordClick}/>}
          <div className="links">
              <span>New to Amie? </span>
              <Link to="/signup" className="signuplink">
                <strong>Sign Up</strong>
              </Link>
            </div>
        </div>
        
      </div>
    </div>
    {showPopup && (
      <div className="popup-container">
        <div className="popup">
          <div className="forgetpassword-head">
          <h3 className="reset-password">Reset Password</h3>
          <span className="close-popup" onClick={handlePopupClose}>×</span>
          </div>
          {resetMessage ? (
              <p>{resetMessage}</p>
            ) : (
              <>
                <span>Enter your email below to reset your password</span>
                <form onSubmit={handleResetPasswordSubmit}>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    required
                  />
                  <button type="submit">Continue</button>
                </form>
              </>
            )}
        </div>
      </div>
    )}</>
  );
};

export default SignInPage;
